<template>
  <div
    class="bg-black-transparent absolute w-full h-full backdrop-filter backdrop-blur-sm top-0 left-0 flex items-center justify-center">
    <div id="excel_upload_popup" class="bg-white classen__rounded h-auto px-5 pb-10 py-5">
      <div class="flex justify-end text-2xl ">
        <p class="cursor-pointer w-min" @click="$emit('close')"><i class="fas fa-times"></i></p>
      </div>
      <p class="text-3xl text-center mx-auto">
        {{ getTranslation('uploadExcel') }}
      </p>
      <div v-if="step === 0">
        <div>
          <div id="excel_label_div"
               class="flex justify-center align-center items-center mx-auto mt-14 cursor-pointer"
               @click="clickImport">
            <p id="excel_label cursor-pointer">
              <template v-if="!file"> {{ getTranslation('clickToBrowseFiles') }}</template>
              <template v-if="file"> {{ getTranslation('fileUploaded') }}</template>
            </p>
          </div>
          <input id="excel_upload" @change="processFile($event)" type="file" accept=".xlsx" class=""
                 placeholder="Choose file"/>
        </div>

        <div class="actions flex justify-center mt-8">
          <button class="classen__button hover__button" @click="$emit('close')">
            <p class="leading-none">{{ getTranslation('cancel') }}</p>
          </button>

          <button class="classen__button classen__button_active ml-5" @click="processImport">
            <p class="leading-none"> {{ getTranslation('importData') }} </p>
          </button>
        </div>
      </div>
      <div v-if="step === 1">
        <div id="excel_upload_success"
             class="text-lg mt-14 flex justify-center align-center items-center">
          <p>{{ getTranslation(statusMessageKey) }}</p>
        </div>
      </div>
    </div>
    <c-loader v-if="isUploading"/>
  </div>
</template>

<script>
import getTranslation from "../../mixins/getTranslation";
import Loader from "../Loader";

export default {
  name: "PopupUploadExcel",

  mixins: [getTranslation],

  components: {
    'c-loader': Loader,
  },

  data() {
    return {
      file: null,
      isUploading: false,
      step: 0,
      statusMessageKey: 'fileSuccessfullyUploaded',
    }
  },

  methods: {
    clickImport() {
      document.querySelector('#excel_upload').click();
    },

    processFile(event) {
      this.file = event.target.files[0];
    },

    processImport() {
      const data = new FormData();
      data.append("file", this.file);
      this.isUploading = true;
      this.$dashboardStore.dispatch('uploadExcel', data)
        .then((res) => {
          this.step = 1;
          if (res.response !== 'imported') {
            this.statusMessageKey = 'somethingWentWrong'
          }

          this.isUploading = false;
        })
        .catch((e) => {
          this.step = 1;
          console.error(e)
          this.statusMessageKey = 'somethingWentWrong'
          this.isUploading = false;
        })
    }
  }
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}

#excel_upload_popup {
  width: 769px;
  height: 336px;
}

#excel_label_div {
  width: 593px;
  height: 80px;
  border: 2px var(--primary) dashed;
}

#excel_upload_success {
  height: 80px;
}
</style>
